import React from 'react';
import { CheckCircle, Download, MonitorSmartphone, Printer, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="bg-dark-900 text-white py-6 md:py-10 px-4 relative overflow-hidden" data-id="element-64">
      {/* Background accent */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[400px] h-[400px] md:w-[800px] md:h-[800px] bg-brand-500/20 rounded-full blur-3xl -z-10 pointer-events-none" data-id="element-65"></div>

      <div className="max-w-5xl mx-auto text-center z-10 relative" data-id="element-66">
        <h1 className="md:text-[64px] font-black mb-4 md:mb-6 uppercase tracking-tight text-white text-[28px]" data-id="element-67">
          MANUAL DE FÓRMULAS
          <span className="block text-brand-400 md:text-[48px] mt-1 md:mt-2 text-[24px]" data-id="element-68">
            PRODUCTOS DE LIMPIEZA
          </span>
        </h1>

        <div className="max-w-xl md:max-w-2xl mx-auto mb-6 relative px-4 md:px-0" data-id="element-69">
          <img src="https://cdn.magicpatterns.com/uploads/pwVCv4aTk6pbnhEfTXxn8a/ChatGPT_Image_Jun_16,_2026,_04_20_16_PM.png" alt="Manual Académico de Fórmulas para Productos de Limpieza" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-70" />
          {/* Guarantee Badge */}
          <div className="absolute -bottom-2 -right-0 md:bottom-4 md:-right-8 bg-brand-500 text-white font-black p-2 md:p-3 rounded-full w-20 h-20 md:w-28 md:h-28 flex flex-col items-center justify-center transform rotate-12 shadow-xl border-2 md:border-4 border-dark-900" data-id="element-71">
            <ShieldCheck className="mb-0.5 md:mb-1 w-5 h-5 md:w-6 md:h-6" data-id="element-72" />
            <span className="text-center leading-tight text-[10px] md:text-xs" data-id="element-73">
              GARANTÍA
              <br data-id="element-74" />7 DÍAS
            </span>
          </div>
        </div>

        <h2 className="text-base md:text-3xl font-bold mb-3 md:mb-4 text-gray-300 px-2 leading-snug pl-[0px] pr-[0px]" data-id="element-75">
          Para personas que quieren crear un{' '}
          <span className="text-brand-400" data-id="element-76">emprendimiento rentable</span> desde
          casa fabricando y vendiendo productos de limpieza.
        </h2>

        <p className="text-sm md:text-xl font-medium mb-6 md:mb-8 max-w-3xl mx-auto leading-relaxed text-gray-400 px-2" data-id="element-77">
          Más de 25 fórmulas listas para usar, guía de materias primas,
          proveedores, capacitación de mantenimiento de piscinas y sistema
          completo para lanzar tu propio negocio.
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4 text-[10px] md:text-sm font-semibold px-2" data-id="element-78">
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-79">
            <Download className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-80" />
            <span data-id="element-81">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-82">
            <CheckCircle className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-83" />
            <span data-id="element-84">Acceso de por vida</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-85">
            <MonitorSmartphone className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-86" />
            <span data-id="element-87">PDF</span>
          </div>
          <div className="flex items-center gap-1.5 md:gap-2 bg-dark-800 px-2.5 py-1.5 md:px-3 md:py-2 rounded-full border border-dark-700 shadow-sm text-gray-200" data-id="element-88">
            <ShieldCheck className="text-brand-400 w-3.5 h-3.5 md:w-4 md:h-4" data-id="element-89" />
            <span data-id="element-90">7 días de garantía</span>
          </div>
        </div>
      </div>
    </section>;
}